import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getRelayAthleteEntryTimeData from './GetRelayAthleteEntryTimeData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  personId: Constants.DEFAULT_ID,
  meetEventId: Constants.DEFAULT_ID,
  legNumber: Constants.DEFAULT_ID
};

const OmeMeetOrgUnitAthleteEntryRosterSelectionData = {
  INITIAL_STATE, getRelayAthleteEntryTimeData
}

export default OmeMeetOrgUnitAthleteEntryRosterSelectionData;